import React from 'react'

export default function ShareMedium(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M3.75 13V19C3.75 20.243 4.758 21.25 6 21.25H18C19.242 21.25 20.25 20.243 20.25 19V13'
        stroke='currentColor'
        strokeWidth={1.5}
      />
      <path d='M12 19.0001V4.00006' stroke='currentColor' strokeWidth={1.55172} />
      <path
        d='M16.7734 8.83403L12.0004 4.06104L7.22644 8.83403'
        stroke='currentColor'
        strokeWidth={1.5}
      />
    </svg>
  )
}
